











































































































import { MessageDialog } from '../../utils/MessageDialog';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SupportPlanService } from '../../biz/remote/SupportPlanService';
import { SupportPlanDTO } from '../../../src_server/entity/dto/SupportPlanDTO';
import { SupportPlanConst } from '../../../src_server/entity/master/SupportPlanConst';
import { dayjs, D_FORMAT_JA } from '../../../src_server/common/momentExtends';
import { Session } from '../../utils/Session';
import { buildingData, getBuildingName } from '../../../src_server/entity/master/buildingData';

@Component({
  components: {},
  filters: {
    formatDt: (dt: Date) => {
      return dayjs(dt).format(D_FORMAT_JA);
    },
  },
})
export default class SupportPlanPrintPage extends Vue {
  private dto: SupportPlanDTO = new SupportPlanDTO();

  get buildingName() {
    return getBuildingName(Session.getSessionBuildingId());
  }

  get supportManager() {
    const building = buildingData.find((b) => b.building_id === Session.getSessionBuildingId());
    return building?.supportManager;
  }

  async print() {
    window.print();
  }
  async close() {
    window.close();
  }

  get longTerm() {
    return this.dto.plan_targets.filter((p) => {
      return p.term_type === SupportPlanConst.LONG_TERM;
    });
  }

  get shortTerm() {
    return this.dto.plan_targets.filter((p) => {
      return p.term_type === SupportPlanConst.SHORT_TERM;
    });
  }

  async created() {
    const support_plan_id = this.$route.query.support_plan_id as string;
    if (!support_plan_id) {
      await MessageDialog.systemError('個別支援計画ID', '個別支援計画印刷ページ表示時', support_plan_id);
      return;
    }

    const biz = new SupportPlanService();
    const response = await biz.getSupportPlan(parseInt(support_plan_id));
    this.dto = response.data;
  }
}
